export const APP_NAME = "Wellness-help";
export const PERSIST_STORE_NAME = "user";
export const REDIRECT_URL_KEY = "redirectUrl";
